module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAAWBAMAAABj+5JWAAAAJ1BMVEUAAAD/th7/th7/th7/th7/th7/th7/th7/th7/th7/th7/th7/th5ekaQCAAAADHRSTlMAsfPMNy4cBLxwb7vogYa4AAAAQUlEQVQoz2Ng8NjCACRaGMAsOBdKBJ45I4qbOAMEg4+wOXPmMG6iSufQcoZKDGI6UAJIMCSKMeAkKAGj4Ux8OAMAhZQe/EkpgekAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/payIcon.png
// module id = E3LT
// module chunks = 1